import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import Modal from '../../molecules/ModalCustomTitle'
import Button from '../../atoms/Button'
import Thumbnail from '../../atoms/Thumbnail'
import Link from '../../molecules/DownloadLink'

const RowStyled = styled(Row)`
  margin-bottom: 60px;
`
const DownloadTitle = styled.h2`
  color: ${({ theme }) => theme.colors.secondary };
  font-size: 1.35rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
`

const DownloadDetails = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`

const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.secondary };
  margin-bottom: 32px;
  margin-top: 32px;
  text-align: justify;
`
class Download extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeLayer: null,
      type: null
    }
    this.onToggleModal = this.onToggleModal.bind(this)
  }

  removeActiveLayer() {
    this.setState({ activeLayer: null })
  }

  onToggleModal(id,type)  {
    this.setState({ activeLayer: id })
    this.setState({ type: type })
  }

  renderLinksAllContent() {
    const { activeLayer, type } = this.state
    const { download } = this.props
    const type_label = (type=="link_all") ? "all" : "groups"
    return (
      <div className="modal-body">
          <h5><FormattedMessage id={"download.layer.button.label."+type_label}></FormattedMessage>: <FormattedMessage id={"name.layer."+download[0]}></FormattedMessage></h5>
          <hr className="my-4"></hr>
          {download[type].map(function (item,i) {
           var download_link =  "download.layer."+activeLayer+".link"
           var download_label =  "download.layer."+activeLayer+".label";

            if (item !== "") {
              download_link = download_link + "."+item;
              download_label = download_label + "."+item;
            }

            return <span key={i}><Link target="_blank" href={this.props.intl.formatMessage({id: download_link})}>{download_label}</Link></span>

          }.bind(this) )}
      </div>
    );
  }

  renderButtons(download) {
    var type_array = [{'key':'link_all', 'value':'all'},{'key':'link_groups', 'value':'groups'},{'key':'link_metodologia', 'value':'metodologia'}];
    return (
      <Row>
        {type_array.map(function(value,key) {
          if (download[value['key']] !== undefined) {
            return (<Col xs="12 py-2" lg="auto">
              <Button onClick={() => this.onToggleModal(download[0],value['key'])} rel="noopener noreferrer">
              {"download.layer.button.label."+value['value']}
              </Button>
            </Col>)
          }
        }.bind(this))}
      </Row>
    )
  }

  render () {
    const { download } = this.props
    const { activeLayer } = this.state
    const modal_title = this.props.intl.formatMessage({id: "download.layer.title.region"})

    return (
      <Container>
        <RowStyled>
          <Col xs="12" lg="3">
            <Thumbnail key={download[0]} thumbKey={"download.layer."+download[0]+".thumbnail"}></Thumbnail>
          </Col>
          <Col xs="12" lg="9">
            <DownloadDetails>
              <div>
                <DownloadTitle>
                  <FormattedMessage id={"name.layer."+download[0]} />
                </DownloadTitle>
                <Paragraph>
                  <FormattedMessage id={"metadata.layer."+download[0]} />
                </Paragraph>
              </div>
            {this.renderButtons(download)}
            </DownloadDetails>
          </Col>
        </RowStyled>
        <Modal
              className='modal-lg'
              title={modal_title}
              onToggle={ this.removeActiveLayer.bind(this) }
              show={ !!activeLayer }
            >
              { activeLayer && this.renderLinksAllContent() }
        </Modal>
      </Container>
    )
  }
}

export default injectIntl(Download)



// WEBPACK FOOTER //
// ./src/components/molecules/Download/Download.js